import React from 'react'
import BatchShipPage from './BatchShipPage'
import '../Styles/index.scss'

function BatchShipPageContainer() {
    return (
        <div className='BatchShipPageContainer'>
            <BatchShipPage/>
        </div>
    )
}

export default BatchShipPageContainer